export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
      
    const integrationApi = $fetch.create({
      baseURL: config.public.API_URL,
      headers: {
        accept: 'application/json',
        'ZC-SIGN-PUB-KEY': config.public.zcSignPublicKey as string,
        'ZC-SIGN-SECRET-KEY': config.public.zcSignSecretKey as string,
      },
      // We don't need to send credentials to the API
      credentials: 'omit',
    });
  
    return {
      provide: {
        integrationApi
      }
    };
  });

// Sample get
//   const { integrationApi } = useNuxtApp();

//   const { data, error } = await useFetch('/signing-session/f683ef36-uuid', {
//     $fetch: integrationApi
//   });

// Sample post
// const { integrationApi } = useNuxtApp();

// const response = await integrationApi('/signing-session', {
//   method: 'post',
//   body: {
//     document_url: '...',
//     document_name: '...',
//     public_key: import.meta.env.NUXT_PUBLIC_ZC_SIGN_PUBLIC_KEY,
//     secret_key: import.meta.env.NUXT_PUBLIC_ZC_SIGN_SECRET_KEY,
//   }
// });
